import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  textContainer: {
    marginTop: typography.pxToRem(35)
  },
  title: {
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(15),
      maxWidth: typography.pxToRem(260)
    },
    [breakpoints.up("sm")]: {
      fontSize: typography.pxToRem(21)
    },
    fontWeight: 300,
    lineHeight: 1.52,
    letterSpacing: 0.44,
    textAlign: "center",
    maxWidth: typography.pxToRem(460)
  },
  subTitle: {
    [breakpoints.down("xs")]: {
      maxWidth: "90%",
      whiteSpace: "unset"
    },
    margin: `${typography.pxToRem(30)} 0 ${typography.pxToRem(30)}`,
    color: "#b7b9bd",
    maxWidth: "inherit"
  },
  icon: {
    marginTop: typography.pxToRem(20),
    fontSize: typography.pxToRem(65),
    color: palette.primary.main,
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(55)
    },
    "& .neighborIcon": {
      fill: "#5ba16b"
    }
  }
}));

const DeliveryInfo = ({
  title,
  actionCode,
  subTitle,
  titleHtml,
  getOptionIcon
}) => {
  const styles = useStyles();
  const OptionIcon = getOptionIcon();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    justify: "center",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(OptionIcon, {
    actionCode: actionCode,
    className: styles.icon
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    justify: "center",
    alignItems: "center",
    className: styles.textContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.title,
    dangerouslySetInnerHTML: titleHtml && {
      __html: titleHtml
    }
  }, title), subTitle && /*#__PURE__*/React.createElement(Typography, {
    className: clsx(styles.title, styles.subTitle)
  }, subTitle)));
};

export default DeliveryInfo;